export default __webpack_public_path__ + "static/ben-burn-consultation@2x-8e1451d76939592ca8fa4b21555ba58d.png";